import Modal from "Common/Components/Modal";
import useInputChange from "hooks/useInputChange";
import { FormEvent, useEffect, useState } from "react";
import {
  SubscriptionPlan,
  SubscriptionPlanFeature,
} from "types/subscription.interface";
import FeatureForm from "../featureForm";
import { ModalBody } from "Common/Components/Modal/ModalContent";

interface Props {
  onSubmit: (data: SubscriptionPlan) => void;
  onCancel: () => void;
  data?: SubscriptionPlan;
  isLoading?: boolean;
}
export default function JobPlanForm({
  onSubmit,
  data,
  isLoading,
  onCancel,
}: Props) {
  const [showFeature, setShowFeature] = useState(false);
  const [feature, setFeature] = useState<SubscriptionPlanFeature | null>(null);

  const { state, onChange, setState } = useInputChange<SubscriptionPlan>({
    name: data?.name || "",
    interval: data?.interval || "",
    description: data?.description || "",
    duration: data?.duration || 7,
    role: [],
    features: [],
    // @ts-ignore
    price: data?.price || "",
  });

  useEffect(() => {
    if (data) setState(data);
  }, [data]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    onSubmit(state);
  };

  const toggleFeature = () => {
    setShowFeature(!showFeature);
  };

  const handleAddFeature = (feature: SubscriptionPlanFeature) => {
    if (feature._id) {
      const updatedFeat = state.features.map((feat) =>
        feat._id === feature._id ? { ...feat, ...feature } : feat
      );
      setState({
        ...state,
        features: updatedFeat,
      });
    } else {
      setState({
        ...state,
        features: state.features.concat(feature),
      });
    }

    setShowFeature(false);
  };

  const handleEdit = (feat: SubscriptionPlanFeature) => {
    setFeature(feat);

    setShowFeature(true);
  };

  return (
    <form action="#!" onSubmit={handleSubmit} key={JSON.stringify(data)}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Name</label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Premium"
          name="name"
          onChange={onChange}
          value={state.name}
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Interval
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="interval"
          onChange={onChange}
          value={state.interval}
        >
          <option value="Daily">Daily</option>
          <option value="Monthy">Monthly</option>
          <option value="Yearly">Yearly</option>
        </select>
      </div>

      {/* <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Duration
        </label>
        <input
          type="number"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="50"
          name="duration"
          onChange={onChange}
          value={state.duration}
        />
      </div> */}

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Price</label>
        <input
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="0.00"
          name="price"
          onChange={onChange}
          value={state.price}
          pattern="[0-9]+"
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Description
        </label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Enter Description"
          name="description"
          onChange={onChange}
          value={state.description}
        />
      </div>

      <div className=" flex flex-col gap-4 my-8">
        <h5 className=" text-base ">Plan Features</h5>

        {state.features?.map((feature) => (
          <div key={feature._id} className="flex items-center  gap-2">
            {/* <p>{feature.name}</p> */}
            <p className=" text-gray-300">{feature.description}</p>
            <span>{feature.available}</span>

            <button
              className="text-[0.75rem]"
              onClick={() => handleEdit(feature)}
            >
              Edit
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={toggleFeature}
          className=" text-custom-500"
        >
          Update features
        </button>
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>

      <Modal
        show={showFeature}
        onHide={() => setShowFeature(false)}
        modal-center="true"
        size="md"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500"
        >
          <Modal.Title className="text-16">Update Feature</Modal.Title>
        </Modal.Header>
        <ModalBody className="p-4 overflow-y-auto">
          <FeatureForm
            onSubmit={handleAddFeature}
            onCancel={() => setShowFeature(false)}
          />
        </ModalBody>
      </Modal>
    </form>
  );
}
